// extracted by mini-css-extract-plugin
export default {"signalQuality":"stats_signalQuality__2N3p8"};